import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import DeleteDeckModal from '../components/DeleteDeckModal';
import ShareDeckModal from '../components/ShareDeckModal';
import DisplayDeck from '../components/DisplayDeck';
import FlashCardModal from '../components/FlashCardModal';
import FlashCardWarning from '../components/FlashCardWarning';
import Page from '../components/Page';

import {
  addDeck,
  deleteDeck,
  deleteWordFromDeck,
  getDecks,
  resetFlashcardGame,
  updateGameState,
  selectDeck,
  copyDeck,
  editDeck,
} from '../redux/decks';
import { getCognitoUser } from '../redux/auth';

function mapStateToProps(state) {
  return {
    decks: state.decks.items,
    selectedDeck: state.decks.selectedDeck,
    user: state.auth.userInformation,
    userIsLoggedIn: state.auth.userIsLoggedIn,
  };
}

class Decks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      decks: [],
      buttonHideClass: 'hide',
      deckToBeDeleted: { id: 0, deckName: '' },
      deckToBeShared: null,
      copiedDeck: null,
      definitionHideClass: 'hide',
      error: null,
      isLoading: false,
      interactionButtonHideClass: '',
      pageNoScroll: false,
      showAddDeckInput: false,
      showDeleteDeckModal: false,
      showFlashcardModal: false,
      showShareDeckModal: false,
      editingDecks: [],
    };
    this.copiedDeckOffset = null;
  }

  componentDidMount() {
    const { params, getCognitoUser, copyDeck } = this.props;
    window.addEventListener('keydown', this.handleEscPress);
    return getCognitoUser()
      .then(user => {
        if (params && params.shareId) {
          return copyDeck(user.sub, params.shareId)
            .then(deck => {
              // Remove shareId from URL to prevent duplicate copies on refresh/navigation
              window.history.replaceState(null, null, window.location.pathname);
              this.setState({ copiedDeck: deck });
              this.getDecks(user).then(decks => {
                this.setState({
                  showShareDeckModal: true,
                  pageNoScroll: true,
                });
              });
            })
            .catch(err => {
              this.setState({
                showShareDeckModal: true,
                pageNoScroll: true,
              });
              this.getDecks(user);
            });
        }
        return this.getDecks(user);
      })
      .catch(err => {
        if (params && params.shareId) {
          window.localStorage.setItem('pendingDeckCopy', params.shareId);
        }
        return this.setState({ error: err.message });
      });
  }

  getDecks = user => {
    return this.props.getDecks(user.sub).then(decks => {
      this.setState({ decks });
    });
  };

  playDeck = e => {
    e.preventDefault();
    const deck = this.props.decks.find(
      deck => deck.deckId === +e.target.id.value
    );
    this.setState({ showFlashcardModal: true, pageNoScroll: true });

    let selectedDeck = { ...deck };
    selectedDeck.deckId = deck.deckId;
    selectedDeck.usedCards = [];
    selectedDeck.unusedCards = deck.cards;
    selectedDeck.currentCardIndex = Math.floor(
      Math.random() * deck.cards.length
    );
    selectedDeck.currentCard =
      selectedDeck.unusedCards[selectedDeck.currentCardIndex];
    selectedDeck.correctCount = 0;
    return this.props.selectDeck(selectedDeck);
  };

  toggleFlashcardModal = () => {
    if (this.state.showFlashcardModal) {
      return this.setState(
        {
          definitionHideClass: 'hide',
          interactionButtonHideClass: '',
          showFlashcardModal: false,
          pageNoScroll: false,
        },
        this.props.resetFlashcardGame()
      );
    }
    this.setState({
      showFlashcardModal: true,
      definitionHideClass: 'hide',
      interactionButtonHideClass: '',
      pageNoScroll: true,
    });
  };

  revealDefinition = () => {
    return this.setState({
      definitionHideClass: '',
      interactionButtonHideClass: 'hide',
    });
  };

  revealDeleteButton = () => {
    return this.setState({ buttonHideClass: '' });
  };

  markAsCorrect = () => {
    this.setState(
      { definitionHideClass: 'hide', interactionButtonHideClass: '' },
      () => {
        this.constructGameState(1);
      }
    );
  };

  markAsIncorrect = () => {
    this.setState(
      { definitionHideClass: 'hide', interactionButtonHideClass: '' },
      () => {
        this.constructGameState(0);
      }
    );
  };

  constructGameState = score => {
    const {
      currentCardIndex,
      unusedCards,
      correctCount,
    } = this.props.selectedDeck;
    let gameState = {
      ...this.props.selectedDeck,
    };
    gameState.unusedCards = [...unusedCards];
    let removedCard = gameState.unusedCards.splice(currentCardIndex, 1);
    removedCard[0].markedCorrect = score > 0 ? true : false;
    gameState.usedCards.push(removedCard[0]);
    gameState.currentCardIndex = Math.floor(
      Math.random() * gameState.unusedCards.length
    );
    gameState.currentCard = gameState.unusedCards[gameState.currentCardIndex];
    gameState.correctCount = correctCount + score;
    return this.props.updateGameState(gameState);
  };

  toggleAddDeckInput = () => {
    this.setState({
      showAddDeckInput: !this.state.showAddDeckInput,
    });
  };

  addNewDeck = e => {
    e.preventDefault();
    const { sub } = this.props.user; // user's ID
    this.setState({ isLoading: true }, () => {
      this.props.addDeck(e.target.deckname.value, sub).then(deck => {
        this.setState({
          showAddDeckInput: false,
          isLoading: false,
        });
      });
    });
  };

  deleteWord = (deckId, wordId) => {
    this.setState({ isLoading: true }, () => {
      this.props.deleteWordFromDeck(deckId, wordId).then(() => {
        this.setState({
          buttonHideClass: 'hide',
          isLoading: false,
        });
      });
    });
  };

  deleteSelectedDeck = deckId => {
    this.setState({ isLoading: true }, () => {
      this.props.deleteDeck(deckId).then(() => {
        this.setState({
          pageNoScroll: false,
          isLoading: false,
          showDeleteDeckModal: false,
        });
      });
    });
  };

  toggleDeleteDeckModal = e => {
    e.preventDefault();
    const deck = this.props.decks.find(
      ({ deckId }) => deckId === +e.target.id.value
    );
    this.setState({
      showDeleteDeckModal: !this.state.showDeleteDeckModal,
      deckToBeDeleted: deck,
      pageNoScroll: !this.state.showDeleteDeckModal,
    });
  };

  toggleShareDeckModal = e => {
    e.preventDefault();
    const deck = this.state.decks.find(
      deck => deck.deckId === +e.target.id.value
    );
    this.setState({
      showShareDeckModal: !this.state.showShareDeckModal,
      deckToBeShared: this.state.showShareDeckModal ? null : deck,
      pageNoScroll: !this.state.showShareDeckModal,
    });
  };

  closeCopiedDeckModal = () => {
    this.setState({
      showShareDeckModal: false,
      copiedDeck: null,
      pageNoScroll: false,
    });
    window.scrollTo(0, this.copiedDeckOffset);
    this.copiedDeckOffset = null;
  };

  setCopiedDeckOffset = offset => {
    this.copiedDeckOffset = offset;
  };

  skipWord = () => {
    let gameState = { ...this.props.selectedDeck };
    gameState.currentCardIndex = Math.floor(
      Math.random() * gameState.unusedCards.length
    );

    if (
      gameState.currentCardIndex === this.props.selectedDeck.currentCardIndex
    ) {
      gameState.currentCardIndex = Math.abs(gameState.currentCardIndex - 1);
    }
    if (gameState.unusedCards.length === 1) {
      gameState.currentCardIndex = 0;
    }

    gameState.currentCard = gameState.unusedCards[gameState.currentCardIndex];

    return this.props.updateGameState(gameState);
  };

  newDeckInput = () => {
    const { showAddDeckInput } = this.state;
    const { userIsLoggedIn } = this.props;
    if (userIsLoggedIn) {
      return (
        <div className="header--add-deck-input-container">
          {showAddDeckInput && (
            <form type="post" onSubmit={this.addNewDeck}>
              <input
                type="text"
                name="deckname"
                autofocus
                required
                placeholder="Name of new deck"
                autocomplete="off"
              />
              <button className="button" type="submit">
                Save deck
              </button>
            </form>
          )}
          {!showAddDeckInput && (
            <button className="button" onClick={this.toggleAddDeckInput}>
              + add new deck
            </button>
          )}
        </div>
      );
    }
    return false;
  };

  handleEscPress = e => {
    if (e.keyCode === 27 || e.key === 'Escape') {
      this.setState({
        showAddDeckInput: false,
        showDeleteDeckModal: false,
        showFlashcardModal: false,
        showShareDeckModal: false,
        pageNoScroll: false,
      });
      if (this.copiedDeckOffset) {
        window.scrollTo(0, this.copiedDeckOffset);
        this.copiedDeckOffset = null;
      }
    }
  };

  editDeck = e => {
    e.preventDefault();
    const payload = {
      id: e.target.id.value,
      deckName: e.target.deckName.value,
    };
    this.props
      .editDeck(payload)
      .then(editedDeck => {
        this.setState({
          editingDecks: this.state.editingDecks.filter(
            deckId => deckId !== editedDeck.deckId
          ),
        });
      })
      .catch(err => this.setState({ error: err.message }));
  };

  makeEditable = deckId => {
    if (this.state.editingDecks.indexOf(deckId) < 0) {
      return this.setState({
        editingDecks: [...this.state.editingDecks, deckId],
      });
    }
  };

  render() {
    const { decks, selectedDeck, userIsLoggedIn } = this.props;
    const {
      deckName,
      deckId,
      unusedCards,
      usedCards,
      cards,
      correctCount,
    } = selectedDeck;
    const {
      buttonHideClass,
      deckToBeDeleted,
      deckToBeShared,
      copiedDeck,
      definitionHideClass,
      interactionButtonHideClass,
      isLoading,
      pageNoScroll,
      showDeleteDeckModal,
      showFlashcardModal,
      showShareDeckModal,
      editingDecks,
    } = this.state;
    return (
      <Page
        isLoading={isLoading}
        title="Flashcards"
        headerSideContent={this.newDeckInput()}
        noScroll={pageNoScroll}>
        <div className="flashcard__container">
          {!userIsLoggedIn && <FlashCardWarning />}

          {showDeleteDeckModal && (
            <DeleteDeckModal
              deck={deckToBeDeleted}
              deckToBeDeleted={deckToBeDeleted}
              deleteSelectedDeck={this.deleteSelectedDeck}
              toggleDeleteDeckModal={this.toggleDeleteDeckModal}
            />
          )}

          {showFlashcardModal && (
            <FlashCardModal
              toggleFlashcardModal={this.toggleFlashcardModal}
              deckName={deckName}
              deckId={deckId}
              unusedCards={unusedCards}
              usedCards={usedCards}
              cards={cards}
              correctCount={correctCount}
              interactionButtonHideClass={interactionButtonHideClass}
              revealDefinition={this.revealDefinition}
              hideClass={definitionHideClass}
              selectedDeck={selectedDeck}
              skipWord={this.skipWord}
              markAsCorrect={this.markAsCorrect}
              markAsIncorrect={this.markAsIncorrect}
              playDeck={this.playDeck}
            />
          )}

          {userIsLoggedIn &&
            decks.length > 0 &&
            decks.map(deck => {
              return (
                <DisplayDeck
                  deck={deck}
                  deleteWord={this.deleteWord}
                  deleteSelectedDeck={this.toggleDeleteDeckModal}
                  playDeck={this.playDeck}
                  revealDeleteButton={this.revealDeleteButton}
                  shareDeck={this.toggleShareDeckModal}
                  copiedDeck={copiedDeck}
                  setCopiedDeckOffset={this.setCopiedDeckOffset}
                  hideClass={buttonHideClass}
                  editing={editingDecks.indexOf(deck.deckId) >= 0}
                  editDeck={this.editDeck}
                  makeEditable={this.makeEditable}
                />
              );
            })}

          {showShareDeckModal && (
            <ShareDeckModal
              sharedDeck={deckToBeShared}
              copiedDeck={copiedDeck}
              closeHandler={
                deckToBeShared
                  ? this.toggleShareDeckModal
                  : this.closeCopiedDeckModal
              }
            />
          )}
        </div>
      </Page>
    );
  }
}

export default connect(mapStateToProps, {
  addDeck,
  deleteDeck,
  deleteWordFromDeck,
  getDecks,
  getCognitoUser,
  resetFlashcardGame,
  selectDeck,
  updateGameState,
  copyDeck,
  editDeck,
})(Decks);



// WEBPACK FOOTER //
// ./src/pages/Decks.js